import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../api';
import './Auth.css';

function Signup() {
  const [values, setValues] = useState({
    nombre: '',
    correo: '',
    password: ''
  });
  const [mensaje, setMensaje] = useState(null); // { tipo: 'success' | 'error', texto: '' }
  const [cargando, setCargando] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleInput = event => {
    setValues(prev => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!values.nombre.trim() || !values.correo.trim() || !values.password) {
      setMensaje({ tipo: 'error', texto: 'Por favor llena todos los campos requeridos.' });
      return;
    }

    setCargando(true);
    setMensaje(null);

    try {
      await axios.post(`${API_URL}/registro`, {
        nombre: values.nombre.trim(),
        correo: values.correo.trim().toLowerCase(),
        password: values.password
      });

      setMensaje({ tipo: 'success', texto: '¡Cuenta creada con éxito! Redirigiendo a iniciar sesión...' });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      const errorMsg =
        err.response?.data?.message ||
        'Error al crear la cuenta. El correo ya existe o hubo un fallo en el servidor.';
      setMensaje({ tipo: 'error', texto: errorMsg });
      setCargando(false);
    }
  };

  return (
    <main className="auth-wrapper">
      <section className="auth-card" aria-labelledby="signup-title">
        {/* Encabezado y Marca */}
        <header className="auth-header">
          <h1 id="signup-title" className="auth-logo-title">
            LEOTECH<span className="auth-logo-dot"></span>
          </h1>
          <p className="auth-subtitle">Crear cuenta nueva</p>
        </header>

        {/* Mensaje de Validación Visual */}
        {mensaje && (
          <div
            className={`auth-alert ${mensaje.tipo === 'success' ? 'auth-alert-success' : 'auth-alert-error'}`}
            role="alert"
          >
            {mensaje.tipo === 'success' ? (
              <svg className="auth-alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            ) : (
              <svg className="auth-alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            )}
            <span>{mensaje.texto}</span>
          </div>
        )}

        {/* Formulario de Registro */}
        <form onSubmit={handleSubmit} noValidate>
          <div className="auth-form-group">
            <label htmlFor="nombre" className="auth-label">Nombre completo</label>
            <div className="auth-input-wrapper">
              <span className="auth-input-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </span>
              <input
                id="nombre"
                type="text"
                name="nombre"
                className="auth-input"
                placeholder="Ej: Leonardo Ramos"
                value={values.nombre}
                onChange={handleInput}
                required
                disabled={cargando}
              />
            </div>
          </div>

          <div className="auth-form-group">
            <label htmlFor="correo" className="auth-label">Correo electrónico</label>
            <div className="auth-input-wrapper">
              <span className="auth-input-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2" />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
              </span>
              <input
                id="correo"
                type="email"
                name="correo"
                autoComplete="email"
                className="auth-input"
                placeholder="nuevo@leotech.com"
                value={values.correo}
                onChange={handleInput}
                required
                disabled={cargando}
              />
            </div>
          </div>

          <div className="auth-form-group">
            <label htmlFor="password" className="auth-label">Contraseña</label>
            <div className="auth-input-wrapper">
              <span className="auth-input-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </span>
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                name="password"
                autoComplete="new-password"
                className="auth-input"
                placeholder="Crea una contraseña segura"
                value={values.password}
                onChange={handleInput}
                required
                disabled={cargando}
              />
              <button
                type="button"
                className="auth-password-toggle"
                onClick={() => setShowPassword(prev => !prev)}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
                tabIndex={-1}
              >
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                    <line x1="2" y1="2" x2="22" y2="22" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Botón Principal Destacado */}
          <button type="submit" className="auth-btn-primary" disabled={cargando}>
            {cargando ? (
              <>
                <span className="auth-spinner" />
                <span>REGISTRANDO…</span>
              </>
            ) : (
              <>
                <span>REGISTRARSE</span>
                <svg className="auth-btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </>
            )}
          </button>

          {/* Enlace para Iniciar Sesión */}
          <div className="auth-forgot-row">
            <Link to="/login" className="auth-forgot-link">
              ¿Ya tienes cuenta? Inicia sesión
            </Link>
          </div>

          {/* Volver a la tienda */}
          <div className="auth-back-container">
            <Link to="/" className="auth-back-link">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
              <span>Volver a la tienda</span>
            </Link>
          </div>
        </form>
      </section>
    </main>
  );
}

export default Signup;